// src/hooks/useTotalLmi.ts
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";

interface TotalLmiResponse {
	proposalId: string;
	lmiTotal: string;
	valor: number;
	valorAprovado: number;
	saldo: string;
}

export function useTotalLmi(id: string, deps: any[] = []) {
	const [data, setData] = useState<TotalLmiResponse | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (id !== "novo") {
			setIsLoading(true);

			SinisterService.totalLmi(id)
				.then((result) => {
					if (result instanceof Error) {
						alert(result.message);
						navigate("/sinistros");
					} else {
						setData(result.data);
					}
				})
				.finally(() => setIsLoading(false));
		}
	}, [id, ...deps]);

	return {
		data, // contém proposalId, lmiTotal, valor, valorAprovado, saldo
		isLoading,
	};
}
